import { EditView } from "./EditView";

export default EditView;
